export default "__VITE_ASSET__BWf9nLmu__";